__turbopack_context__.v({
  "copy": "TalesFanStoryFooter-module-scss-module__3jHX-q__copy",
  "headline": "TalesFanStoryFooter-module-scss-module__3jHX-q__headline",
  "image": "TalesFanStoryFooter-module-scss-module__3jHX-q__image",
  "imageContainer": "TalesFanStoryFooter-module-scss-module__3jHX-q__imageContainer",
  "label": "TalesFanStoryFooter-module-scss-module__3jHX-q__label",
  "lockup": "TalesFanStoryFooter-module-scss-module__3jHX-q__lockup",
  "root": "TalesFanStoryFooter-module-scss-module__3jHX-q__root",
  "showLoadMore": "TalesFanStoryFooter-module-scss-module__3jHX-q__showLoadMore",
  "termsContainer": "TalesFanStoryFooter-module-scss-module__3jHX-q__termsContainer",
  "termsText": "TalesFanStoryFooter-module-scss-module__3jHX-q__termsText",
});
